import Vue from 'vue'
import VueRouter from 'vue-router'
import Api from '../api'
import Login from '../views/auth/Login.vue'
import adminRoutes from './parts/adminRoutes'
import managementRoutes from './parts/management/managementRoutes'
import residentPortalRoutes from './parts/residentPortalRoutes'
import { EUserPermissions } from '@zunta/configurations'
import { bus } from '@/plugins/eventBus'

Vue.use(VueRouter)

const host = window.location.hostname

const routes: any = [
  {
    path: '/',
    name: 'default',
    redirect: { name: host === 'pay.zunta.com' ? 'resident-enter-code' : 'login' },
    component: () => import('../components/layout/Auth.vue'),
    children: [
      {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('../views/auth/ForgotPassword.vue')
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('../views/auth/ResetPassword.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/auth/Register.vue')
      },
      {
        path: '/resident/sign-up',
        name: 'residentSignUp',
        component: () => import('../views/auth/ResidentSignUp.vue')
      },
      {
        name: 'resident-enter-code',
        path: '/resident/enter/:code?',
        component: () => import('../views/auth/ResidentEnter.vue')
      },
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/resident/sign-up/password/:resident?',
        name: 'ResidentSignUpWithPassword',
        component: () => import('../views/auth/ResidentSignUpWithPassword.vue')
      }
    ]
  },

  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/App.vue'),
    children: [
      adminRoutes,
      ...managementRoutes,
      residentPortalRoutes
    ]
  },
  {
    path: '/electronic-record-agreement',
    name: 'electronic-record-agreement',
    component: () => import('../views/common/Agreement.vue')
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('../views/common/Maintenance.vue')
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('../views/common/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to: any, from: any, next: Function) => {
  const goLogin = () => {
    Api.logout(true)
    return next({
      name: 'login',
      query: { nextUrl: to.fullPath }
    })
  }

  bus.$emit('loading:disable')

  if (!to.matched.some((record: any) => record.meta.requiresAuth)) {
    return next()
  }

  if (!Api.validateToken()) {
    return goLogin()
  }

  const user = Api.getUser()

  if (!user) {
    return goLogin()
  }

  if (to.meta && to.meta.permissions) {
    const missedPermission = to.meta.permissions.find((permission: EUserPermissions) => !user.hasPermissionFor(permission))
    if (missedPermission) {
      return next({
        name: 'management-settings'
      })
    }
  }

  if (user.isDataEntry() && !to.matched.some((record: any) => record.meta.dataEntryUser)) {
    return goLogin()
  }

  if (to.matched.some((record: any) => record.meta.zuntaAdminOnly)) {
    if (!user.isAdmin()) {
      return goLogin()
    }
    next()
  } else if (to.matched.some((record: any) => record.meta.onlyChainUser || record.meta.managementOnly)) {
    if (!user.isManager()) {
      return goLogin()
    }
    next()
  } else if (to.matched.some((record: any) => record.meta.residentUserOnly)) {
    if (!user.isResident()) {
      return goLogin()
    }
    next()
  }
  next()
})

export default router
